module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("\nMurder on the Cliffs")]), _c('link', {
    attrs: {
      "href": "css/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "css/page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    staticClass: "dedication-title"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("For Michael O’Regan, my everyday hero, and for three ladies who made it happen: Kim Lionetti, my agent and friend, and Laura Bourgeois and Hope Dellon at St. Martin’s. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Thanks also to April Hearle for her Latin translation.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793dbbbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0